import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

import QRCode from "react-qr-code";
import Container from "@mui/material/Container";
import Link from "@mui/material/Link";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableHead from "@mui/material/TableHead";
import TableContainer from "@mui/material/TableContainer";

import dayjs from "dayjs";
import { useJwtStorage, useLocalStorage } from "../../hooks/useLocalStorage";

import { isMobile } from "react-device-detect";

import Box from "@mui/material/Box";

import HeaderText from "../../components/HeaderText";
import DrawerAppBar from "../../components/DrawerAppBar";
import Title from "../../components/Title";
import ProgressBar from "../../components/ProgressBar";
import { getUserList, getUserListIdQrs } from "../../services/UserService";
import { doService } from "../../services/ServiceHelper";
import { getQrBaseUrl } from "../../services/QrService";
import {
  StripedTableCell,
  StripedTableRow,
} from "../../components/StripedTable";
import TableRowNoResults from "../../components/TableRowNoResults";

const UserListQr = () => {
  const navigate = useNavigate();
  const { eid } = useParams();
  const [_school] = useLocalStorage("Auth", "school", null);
  const [_jwt] = useJwtStorage();
  const [_showProgress, setShowProgress] = useState(false);
  const [_searchPerformed, setSearchPerformed] = useState(false);
  const [_results, setResults] = useState([]);
  const [_userList, setUserList] = useState({});

  useEffect(() => {
    initDetails();
    initMembers();
  }, []);

  const initDetails = () => {
    setShowProgress(true);
    doService(getUserList(_school, _jwt, eid), (result) => {
      setUserList(result.data);
      setShowProgress(false);
    });
  };

  const initMembers = () => {
    setShowProgress(true);
    doService(getUserListIdQrs(_school, _jwt, eid), (results) => {
      setSearchPerformed(true);
      setShowProgress(false);

      getQrBaseUrl(_school, _jwt).then((url) => {
        for (const entry of results.data) {
          entry.url = url + `/user/idqr/${entry.eid}`;
          console.log(entry.url);
        }
        setResults(results.data);
      });
    });
  };

  const getQrCode = (url) => {
    if (isMobile) {
      return (
        <QRCode
          size={256}
          style={{ height: "auto", maxWidth: "80%", width: "80%" }}
          value={url}
          viewBox={`0 0 64 64`}
        />
      );
    } else {
      return <QRCode size={128} value={url} />;
    }
  };

  const onClickLink = (user) => {
    navigate(user.url);
  };

  return (
    <>
      <DrawerAppBar />

      <Container sx={{ mt: 1 }}>
        <Title text={"Student List QR Codes"} showBack={true} />
        <ProgressBar showProgress={_showProgress} />

        <Box sx={{ display: _searchPerformed ? "" : "none" }}>
          <HeaderText text={`Student List QRs: ${_userList != null ? _userList.name: ""}`} />

          <TableContainer component={Paper} sx={{ mt: 1, mb: 1 }}>
            <Table size="small">
              <TableHead>
                <StripedTableRow>
                  <StripedTableCell width={300}>Student</StripedTableCell>
                  <StripedTableCell align="center" width={80}>
                    Grade
                  </StripedTableCell>
                  <StripedTableCell width={100} align="center">QR</StripedTableCell>
                </StripedTableRow>
              </TableHead>
              <TableBody>
                <TableRowNoResults data={_results} />
                {_results.map((user) => (
                  <StripedTableRow key={user.eid}>
                    <StripedTableCell>
                      {user.last_name}, {user.first_name}
                    </StripedTableCell>
                    <StripedTableCell align="center">
                      {user.grade}
                    </StripedTableCell>
                    <StripedTableCell align="center">{getQrCode(user.url)}
                      <br/>
                      <Link onClick={() => onClickLink(user)}>Link</Link>
                    </StripedTableCell>
                  </StripedTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          <p style={{ textAlign: "center", fontStyle: "italic" }}>
            Created {dayjs().format("MM/DD/YY hh:mm a")}
          </p>
        </Box>
      </Container>
    </>
  );
};

export default UserListQr;
